module.exports = __webpack_public_path__ + "i18n/de.e7514b20dfb0a7e23581101c198c3b16.json";


//////////////////
// WEBPACK FOOTER
// ./node_modules/file-loader?name=i18n/[name].[hash].[ext]!./i18n/de.json
// module id = 1537
// module chunks = 60